/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsUserControllerFindManyQueryResponse,
  UserFlagsUserControllerFindMany401,
} from '../types/UserFlagsUserControllerFindMany.ts';

function getUserFlagsUserFindManyUrl() {
  const res = { method: 'GET', url: `/api/user/user-flags` as const };
  return res;
}

/**
 * {@link /api/user/user-flags}
 */
export async function userFlagsUserFindMany(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    UserFlagsUserControllerFindManyQueryResponse,
    ResponseErrorConfig<UserFlagsUserControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getUserFlagsUserFindManyUrl().url.toString(), ...requestConfig });
  return res.data;
}
